enum StateEvent {
	login,
	logout,
	invalidToken
}

export default StateEvent
